<template>
    <div class="login-page">
        <div class="login-page__bg"></div>
        <div class="login-box">
            <div class="card card-outline card-primary">
                <div class="card-header text-center">
                    <a href="javascript:void(0)" class="h1"><b class="mr-1">KB</b>Site </a>
                </div>
                <div class="text-center mt-2">
                    <img class="logo-login" src="../../assets/img/consulting.svg" alt="" />
                </div>
                <div class="card-body">
                    <p class="login-box-msg"></p>
                    <div class="mb-3">
                        <label for="email" class="mb-0"
                            >{{ $t('pageLogin.email') }}
                            <span class="text-danger"> *</span>
                        </label>
                        <div class="input-group">
                            <input
                                type="text"
                                id="email"
                                v-model="email"
                                @keydown="validate('email')"
                                @keyup="validate('email')"
                                @keyup.enter="handleForgot"
                                class="form-control"
                                :class="{ 'input-valid': errorInfo.email }"
                                :placeholder="$t('pageLogin.email')"
                            />
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <span class="fas fa-envelope"></span>
                                </div>
                            </div>
                        </div>
                        <error-message-auth :error="errorInfo.email"></error-message-auth>
                    </div>
                    <div class="mb-3" v-if="selecTypeUser">
                        <div class="form-group d-flex">
                            <label class="d-flex align-items-center mr-4 cursor-pointer" v-for="(item, index) in TYPE_USER_LOGIN" :key="index" :for="'type' + index">
                                <input class="radio_animated mr-1 cursor-pointer" :id="'type' + index" v-model="type" :value="item.value" type="radio" />
                                {{ item.label }}
                            </label>
                        </div>
                    </div>
                    <div class="social-auth-links text-center mt-4 mb-3">
                        <button v-loading="isLoading" :disabled="isLoading" class="btn btn-block btn-primary" @click="handleForgot">
                            {{ $t('button.send') }}
                        </button>
                    </div>
                    <p class="mb-1 text-back">
                        <span class="mr-2">{{ $t('pageLogin.subGoBackLogin') }}</span>
                        <a href="javascript:void(0)" @click="goPath('/login')">{{ $t('button.login') }}</a>
                    </p>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-custom dialog-custom-small" :visible.sync="selecTypeUser">
            <template slot="title">
                <h5 class="modal-title">{{ $t('titleConfirm') }}</h5>
            </template>
            <div class="mb-3 text-bold">
                {{ $t('pageLogin.confirmSelectTypeEmail') }}
            </div>
            <div class="mb-3">
                <div class="form-group d-flex">
                    <label class="d-flex align-items-center mr-4 cursor-pointer" v-for="(item, index) in TYPE_USER_LOGIN" :key="index" :for="'type' + index">
                        <input class="radio_animated mr-1 cursor-pointer" :id="'type' + index" v-model="type" :value="item.value" type="radio" />
                        {{ item.label }}
                    </label>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <div class="text-right py-2">
                    <Button type="warning" @click="selecTypeUser = false" classes="mr-2 btn-sm">
                        {{ $t('button.cancel') }}
                    </Button>
                    <Button type="primary" :disabled="isLoading" v-loading="isLoading" @click="handleForgot" classes="btn-sm">
                        {{ $t('button.login') }}
                    </Button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { APP_TOKEN_NAME } from '@/config/constants';
import { validEmail, validRequired } from '@/utils';
import { TYPE_USER_LOGIN } from '@/config/constants';
import ErrorMessageAuth from '@/views/auth/errorMessageAuth';
import store from '@/store';
import Button from '@/components/partials/Button.vue';

export default {
    name: 'login',
    components: { Button, ErrorMessageAuth },
    data() {
        return {
            selecTypeUser: false,
            TYPE_USER_LOGIN,
            type: TYPE_USER_LOGIN[1].value,
            email: '',
            isLoading: false,
            errorInfo: {
                email: ''
            }
        };
    },
    mounted() {
        let token = this.$cookies.get(APP_TOKEN_NAME);
        if (token) {
            this.$router.push({ path: '/' });
        }
    },
    methods: {
        goPath(path) {
            if (path) {
                this.$router.push(path);
            }
        },
        handleForgot: async function () {
            let check = this.validate();
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                if (!this.selecTypeUser) {
                    let checkEmail = await this.verifyEmailLogin();
                    if (!checkEmail) {
                        this.isLoading = false;
                        return;
                    }
                }
                let successCallback = (response) => {
                    if (response.status === 200) {
                        this.$store.commit('noticeSystem/SET_MESSAGE', {
                            isShowMessage: true,
                            type: 'success',
                            message: this.$t('pageLogin.forgotPasswordSuccess')
                        });
                        this.$store.commit('auth/setEmail', this.email);
                        this.$router.push({ name: 'resetPassword' });
                    }
                    this.selecTypeUser = false;
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.selecTypeUser = false;
                    this.isLoading = false;
                };
                let payload = {
                    data: {
                        email: this.email,
                        ...(this.selecTypeUser && { type: this.type })
                    },
                    successCallback,
                    errorCallback
                };

                this.$store.dispatch('auth/forgotPassword', payload);
            }
        },
        verifyEmailLogin() {
            let successCallback = (response) => {
                let data = response.data.data;
                if (data?.check) return true;
                if (!data?.check) {
                    this.selecTypeUser = true;
                    return false;
                }
            };
            let errorCallback = () => {
                return false;
            };
            let payload = {
                email: this.email,
                successCallback,
                errorCallback
            };
            return this.$store.dispatch('auth/verifyEmailLogin', payload);
        },
        validate() {
            let check = true;
            if (!validRequired(this.email)) {
                this.errorInfo.email = this.$t('pageLogin.errorMail');
                check = false;
            } else if (!validEmail(this.email.trim())) {
                this.errorInfo.email = this.$t('pageLogin.errorMailFormat');
                check = false;
            } else {
                this.errorInfo.email = '';
            }
            return check;
        }
    }
};
</script>

<style lang="scss" scoped>
.login-page {
    &__bg {
        background-image: url('../../assets/images/12-8.jpg');
    }
}
</style>
